import { render, staticRenderFns } from "./novel_create_help.vue?vue&type=template&id=02701662&scoped=true"
import script from "./novel_create_help.vue?vue&type=script&lang=js"
export * from "./novel_create_help.vue?vue&type=script&lang=js"
import style0 from "./novel_create_help.vue?vue&type=style&index=0&id=02701662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02701662",
  null
  
)

export default component.exports